<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form ref="searchForm">
                    <c-form-item type="input" label="申请人" name="apply_name"></c-form-item>
                    <c-form-item type="input" label="申请单号" name="apply_number"></c-form-item>
                    <c-form-item type="select" label="状态" name="state" :options="state"></c-form-item>
                    <c-form-item type="datetime" label="申请时间" start-name="start_date" end-name="end_date"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button color="sys" @click="navigateTo('/special_price_add')">申请特殊价格</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                    label="状态"
                    name="state"
                    width="60"
                >
                  <!--状态;0：草稿；1：待审核；2；审核通过；-1：审核驳回-->
                  <template v-slot="{data}">
                    <span v-if="data.state == 0" style="color:#999"> {{stateText[data.state]}}</span>
                    <span v-if="data.state == 1" style="color:blue"> {{stateText[data.state]}}</span>
                    <span v-if="data.state == 2" style="color:green"> {{stateText[data.state]}}</span>
                    <span v-if="data.state == -1" style="color:red"> {{stateText[data.state]}}</span>
                  </template>
                </c-table-column>

              <c-table-column
                  label="管控类型"
                  name="type"
                  width="80"
              >
                <!--状态;0：草稿；1：待审核；2；审核通过；-1：审核驳回-->
                <template v-slot="{data}">
                  <span v-if="data.type == 1" style="color:blue">按商品</span>
                  <span v-if="data.type == 2" style="color:green">按品牌</span>
                </template>
              </c-table-column>

                <c-table-column
                        label="申请单号"
                        name="apply_number"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="申请人"
                        name="apply_name"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="申请时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="审核人"
                        name="approval_name"
                        width="140"
                >
                  <template v-slot="{data}">
                    <span v-if="data.state == 0||data.state == 1" style="color:#999">--</span>
                    <span v-if="data.state == 2||data.state == -1" style="color:blue"> {{data.approval_name}}</span>
                  </template>
                </c-table-column>

                <c-table-column
                        label="审核时间"
                        name="audit_date"
                        width="140"
                >
                  <template v-slot="{data}">
                    <span v-if="data.state == 0||data.state == 1" style="color:#999">--</span>
                    <span v-if="data.state == 2||data.state == -1" style="color:blue"> {{data.audit_date}}</span>
                  </template>

                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="row">
                        <c-table-button v-if="row.data.state != 0" @click="navigateTo(`/special_price_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="row.data.state <= 0" @click="navigateTo(`/special_price_edit/${row.data.id}`)">编辑</c-table-button>
                        <c-table-button v-if="row.data.state <= 0" @click="deleteInfo(row)">删除</c-table-button>
                        <c-table-button v-if="row.data.state == 1" @click="navigateTo(`/special_price_verify/${row.data.id}`)">审核</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'm_special_price',

        props: {
            apply_state: String
        },

        data() {
            return {
                state: [{
                    name: '草稿',
                    value: '0'
                }, {
                    name: '待审核',
                    value: 1
                }, {
                    name: '审核通过',
                    value: 2
                }, {
                    name: '驳回',
                    value: -1
                }]
            }
        },

        computed: {

            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            },

            defaultSearch() {
                let param = {
                    state: this.apply_state ? this.apply_state : '',
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('specialPriceList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/special_price/list',
                    data
                });
            },

            deleteInfo(item) {
                this.$confirm({
                    text: '确定要删除此特殊价格申请吗？',
                    resolve: () => {
                        this.request({
                            url: '/special_price/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

        }
    }
</script>